import request from "../helpers/request";

const URL = {
  SAVE_WIKI: "wiki/saveWiki",
  GET_WIKI: "wiki/cacheWiki",

  GET_ASSIST_TASK_LIST: "assist/getAssistTaskList",
  SAVE_ASSIST_TASK: "assist/saveAssistTask",
  DELETE_ASSIST_TASK: "assist/deleteAssistTask",
  MOVE_ASSIST_TASK: "assist/moveAssistTask",
};

export default {
  saveWiki(content, material, taskId, text, title) {
    return request(URL.SAVE_WIKI, "POST", {
      content,
      material,
      taskId,
      text,
      title,
    });
  },
  getWiki(id) {
    return request(URL.GET_WIKI, "GET", { id });
  },
  getAssistTaskList(assistRoleId, parentId, page, size) {
    page = page || 1;
    size = size || 1000;
    return request(URL.GET_ASSIST_TASK_LIST, "POST", {
      assistRoleId,
      parentId,
      page,
      size,
    });
  },
  saveAssistTask(form) {
    return request(URL.SAVE_ASSIST_TASK, "POST", form);
  },
  deleteAssistTask(id) {
    return request(URL.DELETE_ASSIST_TASK, "POST", { id });
  },
  moveAssistTask(id, currentId, type) {
    return request(URL.MOVE_ASSIST_TASK, "POST", { id, currentId, type });
  },
};
